import React from 'react';
import { ImageIcon } from 'lucide-react';
import { PendingMarker } from './PendingMarker';
import { testimonials, isTestimonialReady } from '../data/pendingContent';
type TestimonialsProps = {
  draftPreview: boolean;
};
export function Testimonials({
  draftPreview
}: TestimonialsProps) {
  // Publieke versie: alleen complete, echte ervaringen. Werkweergave: alle plekken.
  const items = draftPreview ? testimonials : testimonials.filter(isTestimonialReady);
  if (items.length === 0) return null;
  return <section aria-labelledby="testimonials-title" className="bg-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-221" data-mp="31zmqy0c3ttj9">
      <div className="max-w-6xl mx-auto" data-id="element-222" data-mp="2x1uquj1b313z">
        <h2 id="testimonials-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum" data-id="element-223" data-mp="2x2w48u5snzov">
          Jullie woorden, jullie creaties
        </h2>

        <ul className="mt-10 columns-1 md:columns-2 lg:columns-3 gap-5" data-id="element-224" data-mp="v8wtqb0hxmd8">
          {items.map(t => {
          const hasQuote = t.quote.trim().length > 0;
          const withImage = t.withImage ?? Boolean(t.image);
          return <li key={t.id} className="mb-5 break-inside-avoid" data-id="element-225" data-mp="h8aytf4m6trr">
                <figure className="overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-soft" data-id="element-226" data-mp="m5t14mo4maqs">
                  {withImage && (t.image ? <div className="relative" data-id="element-227" data-mp="7a4xaympzpnf">
                        <img src={t.image} alt={t.imageAlt ?? ''} loading="lazy" decoding="async" className="block aspect-[4/5] w-full object-cover" data-id="element-228" data-mp="c7wp7snd7brm" />
                        {t.imageIsIllustration}
                      </div> : <div className="flex aspect-[4/5] w-full flex-col items-center justify-center gap-3 bg-blush text-center" data-id="element-229" data-mp="14u7nuxrev2ls">
                        <ImageIcon size={28} aria-hidden="true" className="text-berry-deep/70" data-id="element-230" data-mp="q4jymuwi7uef" />
                        <PendingMarker data-id="element-231" data-mp="v3wh73gcefb7">Afbeelding volgt</PendingMarker>
                      </div>)}
                  <div className={withImage ? 'px-6 pb-6 pt-5' : 'p-6 sm:p-7'} data-id="element-232" data-mp="1itza1ls2zpav">
                    {hasQuote ? <blockquote className={`leading-relaxed text-ink ${withImage ? 'text-base' : 'font-serif text-lg sm:text-xl'}`} data-id="element-233" data-mp="1nnbkmrzxdvkm">
                        “{t.quote}”
                      </blockquote> : <div aria-label="Ervaring volgt" data-id="element-234" data-mp="1sk7iakju77zy">
                        <div aria-hidden="true" className="space-y-2.5" data-id="element-235" data-mp="1oh2jot2vnqgl">
                          <div className="h-3 w-full rounded-full bg-ink/10" data-id="element-236" data-mp="1oj5hw0e6opwe" />
                          <div className="h-3 w-11/12 rounded-full bg-ink/10" data-id="element-237" data-mp="1jhy9q084pop7" />
                          <div className="h-3 w-2/3 rounded-full bg-ink/10" data-id="element-238" data-mp="1ejwrtimfvvfb" />
                        </div>
                        <PendingMarker className="mt-4" data-id="element-239" data-mp="19rmw1lyn8154">Echte ervaring volgt</PendingMarker>
                      </div>}
                    {t.name && <figcaption className="mt-4 text-sm" data-id="element-240" data-mp="14r8sag42rdcw">
                        <span className="font-semibold text-plum" data-id="element-241" data-mp="10t1e9t0zwq5e">{t.name}</span>
                        {t.context && <span className="text-ink/70" data-id="element-242" data-mp="vrlt80ytijn0"> · {t.context}</span>}
                      </figcaption>}
                  </div>
                </figure>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}